import { GET, POST, PUT } from '../request'

export const getUsuarioList = () => GET('/api/core/personal/usuario/list')

export const createUsuario = ({ nombre, email, rol, centros, centro }) =>
  POST('/api/core/personal/usuario', {
    nombre,
    email,
    rol,
    'centros[]': centros,
    centro
  })

export const editUsuario = ({ id, nombre, rol, acceso, centros }) =>
  PUT('/api/core/personal/usuario', {
    id,
    nombre,
    rol,
    acceso,
    'centros[]': centros
  })
